"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminUsersByIdLinksPasswordResetSendWatchers = exports.adminUsersByIdLinksPasswordResetSendReducers = void 0;
const post_1 = require("./post.js");
const xuder_1 = require("@sonar-software/xuder");
const redux_1 = require("redux");
exports.adminUsersByIdLinksPasswordResetSendReducers = (0, redux_1.combineReducers)({
    post: post_1.adminUsersByIdLinksPasswordResetPostSlice.asyncReducers
});
exports.adminUsersByIdLinksPasswordResetSendWatchers = (0, xuder_1.combineAllWatchers)([
    post_1.adminUsersByIdLinksPasswordResetPostSlice.asyncWatchers
]);
//# sourceMappingURL=index.js.map